<template>
  <div>
    <div class="mb-6 flex flex-wrap items-end">
      <div
        class="mr-6 flex size-[96px] shrink-0 items-center justify-center rounded-xl bg-article"
      >
        <img
          v-lazy-load
          src="/certificates/logo.png"
          alt=""
          class="h-[76px] w-[69px]"
        />
      </div>
      <p class="mt-5 font-roboto text-lg font-medium leading-[22px]">
        Получите ДИПЛОМ УЧАСТНИКА от Российского военно-исторического общества и
        портала История.РФ
      </p>
    </div>
    <div class="-m-2.5 flex flex-wrap items-center">
      <div
        v-for="(certificate, index) in certificates"
        :key="index"
        class="no-highlight w-full cursor-pointer p-2.5 sm:w-1/2 lg:w-1/3"
        :class="{ selected: index === certificateIndex }"
        @click="select(index)"
      >
        <div class="certificate-preview">
          <MainPageCardsReworkedCommonCardImageBlock
            :data="{
              image: { preview: certificate.image },
            }"
            class="size-full"
            no-rounded
          />
        </div>
        <div class="flex items-center justify-center">
          <div class="radio-button">
            <SvgIcon
              v-if="index === certificateIndex"
              class="tick-icon"
              name="tick"
            />
          </div>
          <span class="text-base font-medium leading-5 text-[#1F1F1F]">
            Выбрать
          </span>
        </div>
      </div>
    </div>
    <div class="grid w-fit grid-flow-col gap-4">
      <BaseTheButtonNew
        class="mb-3 mt-20"
        text="Скачать диплом"
        type="secondary"
        is-small
        @click="downloadCertificate"
      />
      <a
        class="mb-3 mt-20 grid cursor-pointer place-content-center rounded-lg bg-[#ffb800] px-8 text-[14px] leading-[17px] transition-all duration-300 hover:opacity-80"
        target="_blank"
        href="https://rvio.histrf.ru/"
        >САЙТ РВИО</a
      >
    </div>
  </div>
</template>

<script setup>
// defineProps({
//   text: {
//     type: String,
//     default: '',
//   },
// });
const certificates = [
  // {
  //   image: '/certificates/certificate-1.png',
  //   url: '/certificates/histrf-certificate-1.pdf',
  // },
  // {
  //   image: '/certificates/certificate-2.png',
  //   url: '/certificates/histrf-certificate-2.pdf',
  // },
  // {
  //   image: '/certificates/certificate-3.png',
  //   url: '/certificates/histrf-certificate-3.pdf',
  // },
  {
    image: '/certificates/histrf-certificate-3-b.jpg',
    url: '/certificates/histrf-certificate-3-b.jpg',
  },
  {
    image: '/certificates/histrf-certificate-4-c.jpg',
    url: '/certificates/histrf-certificate-4-c.jpg',
  },
  {
    image: '/certificates/histrf-certificate-5-p.jpg',
    url: '/certificates/histrf-certificate-5-p.jpg',
  },
];

const certificateIndex = ref(0);
const select = (index) => (certificateIndex.value = index);
const downloadCertificate = () => {
  // window.open(certificates[certificateIndex.value].url, '_self');
  const link = document.createElement('a');
  link.setAttribute('href', certificates[certificateIndex.value].url);
  link.setAttribute('download', `certificate-${Date.now()}.jpg`);
  link.click();
};
</script>

<style scoped lang="scss">
.clear-before::before {
  content: '';
  clear: both;
}

.tick-icon {
  @apply w-2.5 h-2.5 text-white-100;
}

.certificate-preview {
  @apply mb-5 p-4 rounded-xl border-2 transition-colors duration-300 border-[#E6E6E6];
  .selected & {
    @apply border-[#A10009];
  }
}

.radio-button {
  @apply w-5 h-5 mr-3 flex items-center justify-center border-2 border-[#A10009] rounded-full transition-colors duration-300;
  .selected & {
    @apply bg-[#A10009];
  }
}

.no-highlight {
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}
</style>
